import LoginStyles from 'shared/style/loginStyles'

// LoginManager uses the shared login styles (includes AdminLoginBtn and ControlDiv)
const Style = LoginStyles

export default Style
